import { Avatar, Box, Button, Grid, Typography } from "@material-ui/core";
import React from "react";
import { Mode } from "shared/src/models/poll";
import { CreatorInfo } from "shared/src/network/requests/poll/poll-req-models";
import { userFollow, userUnfollow } from "shared/src/network/requests/user/user-req";
import { colors } from "../theme";

type Props = {
    creator: CreatorInfo;
    name?: string;
    imageSrc?: string;
    variant?: string;
    isVideo?: boolean;
    mode?: Mode;
    isSponsored?: boolean;
};

class Component extends React.Component<Props> {
    handleButtonClick = async () => {
        const { creator } = this.props;
        creator?.id &&
            (creator.isFollowing
                ? await userUnfollow({
                      following: creator?.id,
                      isFollow: !creator.isFollowing,
                  })
                : await userFollow({
                      following: creator?.id,
                      isFollow: !creator.isFollowing,
                  }));
        if (!!creator) {
            creator.isFollowing = !creator?.isFollowing;
        }
        this.setState({});
    };

    render = () => {
        const { name, imageSrc, variant, isVideo, creator, mode, isSponsored } = this.props;
        return (
            <>
                {variant === "column" && mode !== "YOURPOLL" ? (
                    <Grid container direction="row" alignItems="center" wrap="nowrap">
                        <Avatar sx={{ width: 32, height: 32 }} src={imageSrc} />
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                marginLeft: 1,
                            }}>
                            <Button
                                variant={creator?.isFollowing ? "text" : "outlined"}
                                sx={{
                                    color: isVideo ? "#fff" : colors.brand.blue.main,
                                    borderColor: creator?.isFollowing
                                        ? "transparent"
                                        : isVideo
                                        ? "#fff"
                                        : colors.brand.blue.main,
                                    paddingX: creator?.isFollowing ? 0 : 1,
                                    minHeight: 0,
                                    minWidth: 0,
                                    height: "18px",
                                    fontSize: "10px",
                                }}
                                onClick={this.handleButtonClick}>
                                {creator?.isFollowing ? "Following" : "Follow"}
                            </Button>
                            <Typography variant="caption" noWrap>
                                {name}
                            </Typography>
                            {isSponsored && (
                                <Box
                                    component="span"
                                    sx={{ fontSize: "0.625rem", fontWeight: 300, lineHeight: 1 }}>
                                    $ponsored
                                </Box>
                            )}
                        </Box>
                    </Grid>
                ) : mode !== "YOURPOLL" ? (
                    <Grid container direction="row" alignItems="center">
                        <Button
                            variant={creator?.isFollowing ? "text" : "outlined"}
                            sx={{
                                color: isVideo ? "#fff" : colors.brand.blue.main,
                                borderColor: creator?.isFollowing
                                    ? "transparent"
                                    : isVideo
                                    ? "#fff"
                                    : colors.brand.blue.main,
                                paddingX: creator?.isFollowing ? 0 : 1,
                                minHeight: 0,
                                minWidth: 0,
                                height: "18px",
                                fontSize: "10px",
                                display: mode === "YOURPOLL" ? "none" : undefined,
                            }}
                            onClick={this.handleButtonClick}>
                            {creator?.isFollowing ? "Following" : "Follow"}
                        </Button>
                        <Typography sx={{ marginX: 0.5 }} variant="caption" noWrap>
                            {name}
                        </Typography>
                        <Avatar sx={{ width: 18, height: 18 }} src={imageSrc} />
                        {isSponsored && (
                            <Box
                                component="span"
                                sx={{
                                    fontSize: "0.625rem",
                                    fontWeight: 300,
                                    lineHeight: 1,
                                    ml: 0.5,
                                }}>
                                $ponsored
                            </Box>
                        )}
                    </Grid>
                ) : (
                    <Grid container direction="row" alignItems="center">
                        <Avatar sx={{ width: 18, height: 18 }} src={imageSrc} />
                        <Typography sx={{ marginX: 0.5 }} variant="caption" noWrap>
                            {name}
                        </Typography>
                    </Grid>
                )}
            </>
        );
    };
}

const User = Component;

export default User;
